import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {ApplicationsService} from "../../services/applications.service";
import {Application} from "../../interfaces/application.interface";
import {MatDialogRef} from "@angular/material/dialog";
import {MAT_DIALOG_DATA} from '@angular/material/dialog';


@Component({
    selector: 'app-add-edit-application',
    templateUrl: './add-edit-application.component.html',
    styleUrls: ['./add-edit-application.component.scss'],
    standalone: false
})
export class AddEditApplicationComponent implements OnInit {

  public form: any;
  public processing = false;
  errors: any = {};

  constructor(private fb: UntypedFormBuilder, private applicationService: ApplicationsService,
              private dialogRef: MatDialogRef<AddEditApplicationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.form = this.fb.group({
      name: [this.data?.name ?? '', Validators.required],
    });
  }

  ngOnInit(): void {
  }

  submit(event:any) {
    event.preventDefault();
    if(!this.form.valid) return;

    this.processing = true;
    const formData = <Application>this.form.getRawValue();
    if(this.data) formData.id = this.data.id;
    this.applicationService.storeOrUpdate(formData)
      .subscribe(response => {
        this.processing = false;
        this.dialogRef.close(response);
      }, (error: any) => {
          if(error.status == 422){
            this.errors = error.error.errors;
            if(this.errors.errors){
              for(let key in this.errors.errors){
                if(this.form.controls[key]){
                  this.form.controls[key].setErrors({'incorrect': true});
                }
              }
            }
          }
          this.processing = false;
        }
      );
  }

}
